/*
充电看板数据-异常分类占比
 */
import React, { Component } from "react";
import Echarts from "echarts";
import moment from "moment";
import ScGridTable from "@/components/display/table/gridTableCore";
import Tool from "@/utils/Tool";
import { Spin, Tooltip, Button } from "antd";
import ExportJsonExcel from 'js-export-excel';
import { QuestionCircleFilled } from "@ant-design/icons";

class OrderErrorType extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      areaList:[],
      quanguoCityArry:[],
      btnType: 1, // 按钮状态。 1图2表
      tableConfig: null,
    };
  }

  /**
   * 初始化页面方法
   */
  componentDidMount() {
    // 默认加载
    this.stubIntactChart(this.props.dataSource);
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig(this.props.dataSource);
  }


  handleClick = () => {
   
    var option={};
    let dataTable = [];
    if (this.props.dataSource) {
      for (let i in this.props.dataSource) {
        let obj = {}
        obj['故障码'] = this.props.dataSource[i]['end_code'];
        obj['故障描述'] = this.props.dataSource[i]['date'];
        obj['订单数'] = this.props.dataSource[i]['failureOrder'];
        dataTable.push(obj);
      }
    }
    var header = ['故障码', '故障描述', '订单数'];
    option.fileName = '订单故障码统计数据导出'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentWillReceiveProps(nextProps) {
    // 如果数据源改变，则重新渲染图表
    if (JSON.stringify(nextProps.dataSource) !== JSON.stringify(this.props.dataSource)) {
     if (this.state.btnType === 1) {
       this.stubIntactChart(nextProps.dataSource);
      } else {
        this.initTableConfig(nextProps.dataSource);
      }
    }
  }

  /** */
  initTableConfig = (dataSource) => {
    this.setState({
      tableConfig: {
        tableKey: "orderErrorTypeTable",
        tableColumns: [
          {
            name: "日期",
            key: "date",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return Tool.translateTime(text, "YYYY-MM");
            },
          },
          {
            name: "订单总数",
            key: "totalOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功订单数",
            key: "successOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "失败订单数",
            key: "failureOrder",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功率",
            key: "successRate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart = (dataSource) => {
    const dataArry = dataSource.slice(0, 10); // 接口获取数据

    // const chooseDate = this.props.chooseDate[0].format("YYYY-MM");
    const chooseDate = [moment(new Date()).subtract(7, "d"), moment(new Date()).subtract(1, "d")];
    // const year = parseInt(chooseDate.split("-")[0]); // 当前年分
    // const month = parseInt(chooseDate.split("-")[1]); // 当前月份
    const year = 2022; // 当前年分
    const month = 11; // 当前月份

    const failList = [];
    // 处理数据源，转换echarts数据
    dataArry.forEach((v) => {
      failList.push(v.failureOrder);
    });

    // 设置X轴
    const xAxisData = dataArry.map((item) => {
      return item.date;
    });
    const allList = [...failList].sort((a, b) => Number(a.failureOrder) - Number(b.failureOrder));
    console.info('排序')
    console.info(allList)
    let maxVal = 0;

    if (dataArry.length > 0) {
      maxVal = Math.ceil(Number(dataArry[0].totalOrder) / 10) * 10;
    }

    const myChart = Echarts.init(document.getElementById("order-error-count-chart"));
    const option = {
      dataZoom: {
        // type: 'inside',
        showDetail: false,
        startValue: (year - 2020) * 12 + month - 6,
        endValue: (year - 2020) * 12 + month + 7,
        maxValueSpan: 11,
        handleIcon:
          "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "40%",
        handleStyle: {
          color: "#fff",
          shadowBlur: 3,
          shadowColor: "rgba(0, 0, 0, 0.6)",
          shadowOffsetX: 2,
          shadowOffsetY: 2,
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        backgroundColor: "rgba(0,0,0,.5)",
        show: true,
        formatter: (params) => {
          let str = "";
          var pieData = JSON.parse(localStorage.getItem('errorMonthDataList'));
          var one = pieData[params[0].dataIndex]
          if (params[0].axisValue) {
            str += `<div  style="padding:10px 24px 3px 10px">${params[0].axisValue}</div>`;
            str += `<div  style="padding:3px 24px 12px 10px">订单数：${one.failureOrder}，占比：${one.successRate}%</div>`;
            return str;
          }
        },
        // position: function (pos, params, dom, rect, size) {
        //     // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
        //     var obj = { top: 60 };
        //     obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
        //     return obj;
        // }
      },
      color: ["#CDDAE7", "#5B8FF9"],
      legend: {
        selectedMode: false,
        textStyle: {
          padding: [10, 0],
        },
        top: 0,
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [
          {
            name: "成功率",
          },
          {
            name: "成功订单",
          },
          {
            name: "失败订单",
          },
        ],
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
        },

        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
      ],
      grid: {
        left: "90px",
        right: "50px",
      },
      yAxis: [
        {
          type: "value",
          name: "数量",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          interval: Math.ceil(maxVal / 10),
          max: maxVal,
          axisLabel: {
            formatter: "{value}",
          },
          nameTextStyle: {
            padding: [0, 25, 10, 0],
            color: "#666",
          },
        },
        {
          type: "value",
          name: "百分比",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: 100,
          interval: 10,
          nameTextStyle: {
            padding: [0, 0, 10, 40],
            color: "#666",
          },
          axisLabel: {
            formatter: "{value}%",
          },
        },
      ],
      series: [
        {
          name: "订单数",
          type: "bar",
          yAxisIndex: 0,
          stack: "1",
          data: failList,
          barGap: "-100%",
        },
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
        // this.stubIntactChart();
      },
    };
    myChart.clear();
    myChart.setOption(option);
    // 图表中柱状图点击执行，修改选择月份，传递至父组件
    myChart.on("click", (obj) => {
      this.props.setChooseDate(moment(xAxisData[obj.dataIndex]));
    });
  };

  changeCityData = (type) => {
    this.setState(
      {
        btnType: type,
      },
      () => {
        if (type === 1) {
          this.stubIntactChart(this.props.dataSource);
        } else {
          this.initTableConfig(this.props.dataSource);
        }
      },
    );
  };
  btnChange = (type) => {
    this.setState(
      {
        btnType: type,
      },
      () => {
        if (type === 1) {
          this.stubIntactChart(this.props.dataSource);
        } else {
          this.initTableConfig(this.props.dataSource);
        }
      },
    );
  };

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className='section'>
          <div className='title-box' style={{display:"flex", justifyContent:"space-between"}}>
            <div className='title'>异常分类占比<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内不同停止原因产生的订单数占总订单数的比例柱状图</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip></div>

                      <div style={{    display: 'flex',alignItems: 'center'}}>
                        <Button
                        onClick={this.handleClick}
                        type="primary"
                        style={{ margin: "5px" }}>
                        导出
                      </Button>
                      </div>
            

                {/* <div className="search-box">
                  <span className="select-label"></span>
                  <Select
                    style={{ width: "120px", marginRight: "8px" }}>
                      {this.state.areaList.map((v) => (
                    <Select.Option value={v.value}>{v.text}</Select.Option>
                  ))}
                  </Select>
                  <TreeSelect
                    style={{ width: "200px" }}
                    treeData={this.state.quanguoCityArry}
                    onChange={this.changeCityData}
                    placeholder={'请选择地区'}
                    allowClear
                    className="form-core-tree-select"
                    showSearch
                    treeCheckable={true}
                    treeCheckStrictly={false}
                    treeNodeFilterProp="title"
                    showCheckedStrategy={'SHOW_PARENT'}
                  />

                </div> */}
          </div>
          {this.state.btnType === 1 ? (
            <div
              style={{ width: "100%", height: 420, overflowY: "auto" }}
              id='order-error-count-chart'
            />
          ) : (
            <ScGridTable config={this.state.tableConfig} />
          )}
        </div>
      </Spin>
    );
  }
}

export default OrderErrorType;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/orderErrorType.js